import { sortArray } from "core/utils/parsers";

import { SHOWN_OBJECT_IDS } from "./Constants";

export const NAVIGATION_STATUS = {
  NAVIGATING: "NAVIGATING",
  PROCESSING: "PROCESSING",
  PLANNED: "PLANNED",
  FINISHED: "FINISHED",
  CANCELLED: "CANCELLED",
};

export function prettyName(name) {
  if (name) {
    // Object names come hyphen/underscore-delimited (e.g. "shelf-labels"); split on
    // both and capitalize every word -> "Shelf Labels".
    return titleCase(name.replace(/[-_]/g, " "));
  }
  return name;
}

export function formatDate(date) {
  const currentMonth = date.getMonth() + 1;
  const currentDay = date.getDate();
  const month = currentMonth < 10 ? `0${currentMonth}` : currentMonth;
  const day = currentDay + 1 < 10 ? `0${currentDay}` : currentDay;
  return (
    `${date.getFullYear()}-${month}-${day}`
  );
}

// Current date in UTC as "yyyy-MM-dd" — session dates and pipeline timestamps
// are UTC, so "today" in the monitoring views must follow the UTC clock, not
// the browser's timezone.
export function utcToday() {
  return new Date().toISOString().slice(0, 10);
}

/**
 *
 * @param {str} str
 * @returns {str} the string with all its first letters capitalize.
 * Example titleCase('helLo how ARE you') => 'Hello How Are You'
 */
export function titleCase(str) {
  let splitStr = str.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

// Distinct chains for the fleet filter, sourced from the session-progress-table feed
// (each session carries its `chain`). Scopes the dropdown to chains that actually have
// sessions for the selected date — no separate store-metadata query needed.
export function getAllChainsFromSessionData(sessionData) {
  const allChains = new Set();
  for (const session of Object.values(sessionData || {})) {
    if (session?.chain) {
      allChains.add(session.chain);
    }
  }
  return sortArray(Array.from(allChains));
}

// Builds the ordered cell array for one session row: the navigation cell first, then one
// cell per id in SHOWN_OBJECT_IDS. Object cells are matched to the backend payload BY
// `objectId` (not by array position), so the column order is owned solely by
// SHOWN_OBJECT_IDS and stays aligned with the table headers regardless of what order or
// which extra/missing objects the backend sends. An id the backend didn't return renders
// as an empty cell instead of shifting every column after it. This is what keeps the
// header/cell contract from desyncing when objects are added or removed on either side.
export function buildAlignedSessionCells(sessionDict) {
  const objectById = new Map(
    (sessionDict?.objectData ?? []).map((object) => [object.objectId, object])
  );
  const objectCells = SHOWN_OBJECT_IDS.map(
    (objectId) =>
      objectById.get(objectId) ?? {
        objectId,
        processNames: ["Batches"],
        progressValues: [0],
        maxValue: 0,
      }
  );
  return [sessionDict?.navigationData, ...objectCells];
}

export function checkViewOnlyPermision(navigationOptions, viewId) {
  let view = navigationOptions.find(
    (element) => element.description === viewId
  );
  if (view) return view.view_only;
  return true;
}
